import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import toast from 'react-hot-toast';
import { getErrorString } from '../../utils';
import { getQueryString } from '../../utils/filters-util';
import { fetchTeamApi, fetchTeamsListApi, newTeamApi } from '../../api/teams-api';
import { setQuickLinks } from 'reducers/quick-links-slice';

const initialState = {
  activeColumns: [],
  teams: [],
  departments: [],
  data: {},
  ticketTypes: [],
  loading: true,
  pending: false,
  pagination: {},
};

export const fetchTeamsListing = createAsyncThunk('teams/listing', async (updatedParamsObject = {}, { dispatch }) => {
  try {
    const paramsObj = {
      ...updatedParamsObject,
    };
    const res = await fetchTeamsListApi({}, getQueryString(paramsObj));
    if (res?.status) {
      dispatch(setQuickLinks(res?.user_filters));
    }
    return res;
  } catch (error) {
    toast.error(getErrorString(error));
  }
});

export const fetchTeamDetails = createAsyncThunk('teams/details', async ({ id = '' }) => {
  try {
    const res = await (id ? fetchTeamApi(id) : newTeamApi());
    return res;
  } catch (error) {
    toast.error(getErrorString(error));
  }
});

const TeamsSlice = createSlice({
  name: 'teams',
  initialState,
  reducers: {
    setTeamsLoading: (state, action) => {
      state.loading = action?.payload?.loading;
    },
    setTeamsActiveColumn: (state, action) => {
      state.activeColumns = action?.payload?.activeColumns;
    },
    setTeamData: (state, action) => {
      state.data = action?.payload;
    },
  },
  extraReducers(builder) {
    builder
      .addCase(fetchTeamsListing.pending, (state) => {
        state.pending = true;
      })
      .addCase(fetchTeamsListing.fulfilled, (state, action) => {
        if (state.loading) {
          //means first time loading
          state.activeColumns = action?.payload?.active_columns || [];
        }
        state.teams = action?.payload?.data || [];
        state.departments = action?.payload?.departments || [];
        state.loading = false;
        state.pending = false;
        state.pagination = action?.payload?.meta?.pagination || {};
      })
      .addCase(fetchTeamsListing.rejected, (state) => {
        state.loading = false;
        state.pending = false;
      })
      .addCase(fetchTeamDetails.pending, (state) => {
        state.data = {};
        state.pending = true;
      })
      .addCase(fetchTeamDetails.fulfilled, (state, action) => {
        state.data = action?.payload?.data || {};
        state.ticketTypes = action?.payload?.ticket_types || [];
        state.departments = action?.payload?.departments || [];
        state.pending = false;
      })
      .addCase(fetchTeamDetails.rejected, (state) => {
        state.pending = false;
      });
  },
});

export const { setTeamsActiveColumn, setTeamsLoading, setTeamData } = TeamsSlice.actions;
export default TeamsSlice.reducer;
